import { mentorService } from '../services'

export const mentor = {
    namespaced: true,
    state: {
        all: {},
        data: {}
    },
    actions: {
        async getMentorData({ commit }) {
            commit('MENTOR_DATA_REQUEST')

            await mentorService.getMentorTeamData()
                .then( data => commit('MENTOR_DATA_SUCCESS', data),
                error => commit('MENTOR_DATA_FAILURE',{error}))
        },
},
    mutations: {
        MENTOR_DATA_REQUEST(state) {
            state.all = { loading: true }
        },

        MENTOR_DATA_SUCCESS(state, data) {
            state.data=data
        },
        MENTOR_DATA_FAILURE(state, error) {
            state.all = { error }
        },

    }
}
